import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAppendixDocumentDropdownAsync,
  getAppendixHtmlAsync,
  saveAppendixAsync
} from "./certificateAppendix.async";

const initialState = {
  appendixDocumentDropDownLoader: false,
  appendixDocumentDropDown: [],

  appendixHtmlLoader: false,
  appendixHtml: {},

  appendixSaveLoader: false,
  appendixSaveInfo: {}
};

export const certificateAppendixSlice = createSlice({
  name: "certificateAppendix",
  initialState,
  extraReducers: (builder) => {
    // Appendix Document Drop Down
    builder.addMatcher(
      isAnyOf(getAppendixDocumentDropdownAsync.pending),
      (state) => {
        state.appendixDocumentDropDownLoader = true;
        state.appendixDocumentDropDown = [];
      }
    );
    builder.addMatcher(
      isAnyOf(getAppendixDocumentDropdownAsync.fulfilled),
      (state, action) => {
        state.appendixDocumentDropDownLoader = false;
        state.appendixDocumentDropDown = action.payload?.data || [];
      }
    );
    builder.addMatcher(
      isAnyOf(getAppendixDocumentDropdownAsync.rejected),
      (state) => {
        state.appendixDocumentDropDownLoader = false;
        state.appendixDocumentDropDown = [];
      }
    );

    // Appendix Html By Document Id
    builder.addMatcher(isAnyOf(getAppendixHtmlAsync.pending), (state) => {
      state.appendixHtmlLoader = true;
      state.appendixHtml = {};
    });
    builder.addMatcher(
      isAnyOf(getAppendixHtmlAsync.fulfilled),
      (state, action) => {
        state.appendixHtmlLoader = false;
        state.appendixHtml = action.payload;
      }
    );
    builder.addMatcher(isAnyOf(getAppendixHtmlAsync.rejected), (state) => {
      state.appendixHtmlLoader = false;
      state.appendixHtml = {};
    });

    // Save Appendix
    builder.addMatcher(isAnyOf(saveAppendixAsync.pending), (state) => {
      state.appendixSaveLoader = true;
      state.appendixSaveInfo = {};
    });
    builder.addMatcher(
      isAnyOf(saveAppendixAsync.fulfilled),
      (state, action) => {
        state.appendixSaveLoader = false;
        state.appendixSaveInfo = action.payload;
      }
    );
    builder.addMatcher(isAnyOf(saveAppendixAsync.rejected), (state) => {
      state.appendixSaveLoader = false;
      state.appendixSaveInfo = {};
    });
  },
  reducers: {
    emptyCertificateAppendix: () => {
      return initialState;
    }
  }
});

export const { emptyCertificateAppendix } = certificateAppendixSlice.actions;
export default certificateAppendixSlice.reducer;
